import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Title } from './Title';
export function Header({ sorted = false, ...other }) {
    return (_jsxs("div", { children: [_jsx(Title, { ...other, children: "Header" }), sorted
                ? {
                    asc: ' 🔼',
                    desc: ' 🔽',
                }[sorted]
                : null] }));
}
//# sourceMappingURL=Header.js.map